<ng-container *ngIf="footerType === 'score'">
  <div fxLayout="row" fxLayoutAlign="center center" class="height-100" style="padding-bottom: 12px;">
    <ng-container *ngIf="project.evaluation_score; else noEvalScore">
      <h6 class="margin-0 sparro-yellow-800" style="font-size:16px;" [ngClass]="{'sparro-green-600': project.evaluated }">
        Score: {{ project.evaluation_score }}
      </h6>
    </ng-container>

    <ng-template #noEvalScore>
      <h6 class="sparro-orange-800 margin-0" style="font-size:16px;">
        Score: N/E
      </h6>
    </ng-template>
  </div>
</ng-container>

<ng-container *ngIf="footerType === 'disciplines' && project.content.disciplines">
  <div class="text-center margin-bottom-3 margin-x-3">
    <ng-container *ngFor="let discipline of project.content.disciplines.slice(0, featured ? 4 : 2); let i = index">
      <a [href]="goToTopic(discipline.slug)" *ngIf="discipline.slug" class="font-xxs margin-x-2 sparro-grey-800 pointer no-decor-hover" >{{ discipline.name }}</a>
      <span (click)="goToDiscipline(discipline)" *ngIf="!discipline.slug" class="font-xxs margin-x-2 sparro-grey-800 pointer" >{{ discipline.name }}</span>
    </ng-container>
  </div>
</ng-container>

<ng-container *ngIf="footerType === 'timestamp' && project.content.updated_at">
  <div class="text-center margin-bottom-3 margin-x-3 font-xxs sparro-grey-800">
    Last edited: {{ project.content.updated_at | timesince }} ago
  </div>
</ng-container>


<ng-container *ngIf="footerType === 'none'">

</ng-container>
